@if (literalSubstrings) {
  @for (substring of literalSubstrings; track substring; let i = $index) {
    <a (mouseenter)="hovering = i" (mouseleave)="hovering = undefined">
      <span [ngClass]="hovering == i ? 'interactive-text-hover' : 'interactive-text'"
      (click)="select(substring, i)">{{substring}}</span>
      @if (i < literalSubstrings.length - 1 && literalSubstrings.length > 1) {
        <span class="colon-text"> {{', '}}</span>
      }
    </a>
  }
} @else {
  <a (mouseenter)="hovering = true" (mouseleave)="hovering = undefined">
    <span [ngClass]="hovering ? 'interactive-text-hover' : 'interactive-text'"
    (click)="select(literal)">{{literal}}</span>
  </a>
}
